import { rowStyleClasses } from './row-style-classes.js'

export function cellClass (cellParams) {
  const rowStyles = rowStyleClasses(cellParams)

  const classes = [...rowStyles, 'right', 'number']
  if (!cellParams.value || Math.abs(cellParams.value) < 1) {
    classes.push('zero')
  }

  return classes
}
